import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import {
  Category,
  Product,
  User,
  Banner,
  CategoryBanner,
  LoginRequest,
  RegistrationRequest,
  OrderShort,
  Country,
  SaveUserDataRequest,
  SaveUserDataFromOrderFormalizationPageRequest,
  DiscountCertificate,
  DiscountCoupon,
  NewOrderRequest,
  NewsPost,
  OrderPaymentRequest
} from './app.models';


// ******************************************************* DATA CLASS **************************************************
export class Data {
  constructor(  public user: User,
                public categories: Category[],
                public searchedProducts: Product[],
                public cartList: Product[],
                public discountCertificatesArray: DiscountCertificate[],
                public discountCouponsArray: DiscountCoupon[],
                public totalCartCount: number,
                public totalCartPrice: number,
                public newsPosts: NewsPost[]
  ) { }
        }


// *************************************************** APP SERVICE CLASS ************************************************
@Injectable()
export class AppService {
  public Data = new Data(
        null, // user
        [], // categories
        [], // searched products
        [],  // cartList
        [], // discountCertificatesArray
        [],  // discountCouponsArray
        0, //totalPrice
        0, //totalCartCount
        [] // newsPosts
  )

  public isUserLoggedIn = false;
  //public apiUrl = 'http://172.20.10.8:8080/ws';
  public apiUrl = 'https://www.thaicos-cms.ru:443/ws';



  // -- FUNC Constructor 
  constructor(public http: HttpClient, public snackBar: MatSnackBar, public router: Router) { }


  // ***************************************************** LOGIN *******************************************************
  // -- FUNC Create Initial User
  public createInitialUser() {
    var initialUser = new User(
      2121, //id
      'Гость', // name
      'visitorthaicos@gmail.com', // email
      null, // faebookId
      null, // phone
      '', // gender
      null, // birthdate
      'web', // platform
      1, // countryId 
      1, // provinceId
      null, // addressIndex
      '', // address
      'Active', // status
      '', // accesstoken
      0, // currencId
      1, // currencyRate
      0 // rmbDollarCurrencyRate
    );

    this.Data.user = initialUser;

  }


  // -- FUNC Get Security Key From Api And Login With Given Credentionals
  public getSecurityKeyFromApiSaveItAndLoginWithGiveCredentionals(fromWhat: string, receivedLoginRequest: LoginRequest ) {

    // pack get api key request
    var getApiKeyRequest = new HttpParams()
      .set('X-API-KEY', '6d9f729b765aae27f45e5ef9150fa073f8a61b94');

    var responce = this.http.put(this.apiUrl + '/key', getApiKeyRequest, {
         observe: 'response', responseType: 'text'
      }).subscribe(resp => {

        // save api key to storage
        var jsonKey = JSON.parse(resp.body);
        localStorage.setItem('ReceivedApiSecurityKey', jsonKey['key']);

        //console.log("KEY" + jsonKey['key']);

        // Pack Login Request
        var loginRequest = new HttpParams()
          .set('vEmail', receivedLoginRequest.loginEmail)
          .set('vPassword', receivedLoginRequest.loginPassword)
          .set('vDeviceToken', '')
          .set('ePlatform', receivedLoginRequest.loginPlatform);

        // perform login
        this.loginWithGivenCredentials(fromWhat, loginRequest);
 
      });

  }


  // -- FUNC Login With Given Credentials 
  public loginWithGivenCredentials(fromWhat: string, loginRequest: HttpParams)
  {

    // Create headers for request
    let headers = new HttpHeaders({
      'X-API-KEY': localStorage.getItem('ReceivedApiSecurityKey'),
    });

    // Create options 
    let options = { headers: headers };

    this.http.post(this.apiUrl + '/TCPublic/loginModule/login', loginRequest, options).subscribe(data => {
      var json = JSON.parse(JSON.stringify(data));

      // check status and if it is ok then save received user data
      if (data['status'] == 1) {
        //console.log("TRUE ON LOGIN");
        var user = <User>data['user_data'];
        this.Data.user = user;
        localStorage.setItem('isUserLoggedIn', "Yes");

        // check if we already have a saved currency id and if yes then get it, get currency rate for this currency and save them
        if (localStorage.getItem('currentCurrencyIdIsSaved') == 'Yes') {

          var savedCurrentCurrencyId = localStorage.getItem('currentCurrencyId');
          var currencies = this.getCurrencies();

          var currentCurrencyCode = currencies[savedCurrentCurrencyId].code;

          this.getRateForUserCurrency(currentCurrencyCode).subscribe(data => {
            // check responce status
            if (JSON.stringify(data) != '{}' && data['CNY_' + currentCurrencyCode] != '' && data['CNY_' + currentCurrencyCode] != 'null') {
              //console.log("TRUE ON GET CURRENCY RATE" + JSON.stringify(data));

              // save received currency data
              this.Data.user.currencyRate = data['CNY_' + currentCurrencyCode]
              this.Data.user.currencyId = Number(savedCurrentCurrencyId);
            }
            else {
              this.snackBar.open("Произошла ошибка при запросе о курсе валюты. Установлена валюта по умолчанию - ¥ Юань Кнр.", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });

              this.Data.user.currencyRate = 1.0;
              this.Data.user.currencyId = 0;

              //console.log("FALSE ON GET CURRENCY RATE");
            }
          });

        }
        // else if we dont have already saved currency then check if we did receive a currency id from server
        // and if we didnt then set the default value as user currency
        else {
          if (this.Data.user.currencyId == null) {
            this.Data.user.currencyId = 0;
          }
          if (this.Data.user.currencyRate == null) {
            this.Data.user.currencyRate = 1;
          }

        }

        this.isUserLoggedIn = true;
        localStorage.setItem('wasUserLoggedInBefore', 'Yes');
        localStorage.setItem('userEmail', loginRequest.get('vEmail'));
        localStorage.setItem('userPassword', loginRequest.get('vPassword'));

        // get usd/cny currency rate
        this.getRateForCnyUsdCurrency();

        // if we came from sign-in move to account
        if (fromWhat == "SignIn") {
          this.router.navigate(['/account']);
        }
      }
      else {
        console.log("FALSE ON LOGIN ");
        this.snackBar.open(data['message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
      }
    });;
  }



  // -- FUNC Get Security Key From Api And Register With Given Credentionals
  public getSecurityKeyFromApiSaveItAndRegisterWithGiveCredentionals(receivedRegistrationRequest: RegistrationRequest) {

    // pack get api key request
    var getApiKeyRequest = new HttpParams()
      .set('X-API-KEY', '6d9f729b765aae27f45e5ef9150fa073f8a61b94');

    var responce = this.http.put(this.apiUrl + '/key', getApiKeyRequest, {
      observe: 'response', responseType: 'text'
    }).subscribe(resp => {

      // save api key to storage
      var jsonKey = JSON.parse(resp.body);
      localStorage.setItem('ReceivedApiSecurityKey', jsonKey['key']);

      //console.log("KEY" + jsonKey['key']);

      // Pack Registration Request
      var registrationRequest = new HttpParams()
        .set('vUserName', receivedRegistrationRequest.registrationName)
        .set('vEmail', receivedRegistrationRequest.registrationEmail)
        .set('vPassword', receivedRegistrationRequest.registrationPassword)
        .set('vDeviceToken', '')
        .set('invitationCode', receivedRegistrationRequest.registrationInvitationCode)
        .set('ePlatform', receivedRegistrationRequest.registrationPlatform);

      // perform login
      this.registerWithGivenCredentials(registrationRequest);

    });

  }


  // -- FUNC Register With Given Credentials 
  public registerWithGivenCredentials(registrationRequest: HttpParams) {

    // Create headers for request
    let headers = new HttpHeaders({
      'X-API-KEY': localStorage.getItem('ReceivedApiSecurityKey'),
    });

    // Create options 
    let options = { headers: headers };

    this.http.post(this.apiUrl + '/TCPublic/loginModule/index', registrationRequest, options).subscribe(data => {
      var json = JSON.parse(JSON.stringify(data));

      // check status and if it is ok then save received user data
      if (data['status'] == 1) {
        //console.log("TRUE ON REGISTRATION");
        var user = <User>data['user_data'];
        this.Data.user = user;
        this.Data.user.currencyId = 0;
        this.Data.user.currencyRate = 1;
    
        this.isUserLoggedIn = true;
        localStorage.setItem('wasUserLoggedInBefore', 'Yes');
        localStorage.setItem('userEmail', registrationRequest.get('vEmail'));
        localStorage.setItem('userPassword', registrationRequest.get('vPassword'));

        // get usd/cny currency rate
        this.getRateForCnyUsdCurrency();

        // move to account
        this.router.navigate(['/account']);
      }
      else {
        //console.log("FALSE ON REGISTRATION ");
        this.snackBar.open(data['message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
      }
    });;
  }


  //this.getRateForUserCurrency(this.currency);
  //}


  // -- FUNC Get Rate For Usd Cny Currency
  private getRateForCnyUsdCurrency() {

    // pack get usd/cny currency rate request
    var getCnyUsdCurrencyRateRequest = new HttpParams()
      .set('q', 'USD_CNY')
      .set('compact', 'ultra')
      .set('apiKey', '2f7ed345-a35e-4e58-bb96-039ddfb3ed99');

    this.http.get('https://api.currencyconverterapi.com/api/v5/convert', {
      params: getCnyUsdCurrencyRateRequest
    }).subscribe(data => {
      // check responce status
      if (JSON.stringify(data) != '{}' && data['USD_CNY'] != '' && data['USD_CNY'] != 'null') {
        //console.log("TRUE ON GET USD CNY CURRENCY RATE" + JSON.stringify(data));

        // save received currency data
        this.Data.user.rmbDollarCurrencyRate = data['USD_CNY'];
      }
      else {
 
        //console.log("FALSE ON GET USD CNY CURRENCY RATE");
      }
    });
}


  // -- FUNC Perform Forgot Password
  public perfromForgotPassword(receivedEmail: string) {

    // Create headers for request
    let headers = new HttpHeaders({
      'X-API-KEY': '6d9f729b765aae27f45e5ef9150fa073f8a61b94'
    });

    // Create options 
    let options = { headers: headers };

    // Pack Login Request
    var forgotPasswordRequest = new HttpParams()
      .set('vEmail', receivedEmail);


    this.http.post(this.apiUrl + '/TCPublic/loginModule/forgotpassword', forgotPasswordRequest, options).subscribe(resp =>
    {

      // unpack responce
      var json = JSON.parse(JSON.stringify(resp));
      if (resp['status'] == 1) {
        //console.log("TRUE ON FORGOT PASSWORD ");
        this.snackBar.open(resp['message'], '×', { panelClass: 'style-success', verticalPosition: 'bottom', duration: 5000 });
      }
      else {
        //console.log("FALSE ON FORGOT PASSWORD ");
        this.snackBar.open(resp['message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });
      }

    });

  }


  // -- FUNC Perform Update User Data With Id
  public performUpdateUserDataWithId(userId: string): Observable<any> {

    // Create headers for request
    let headers = this.getHeader();

    // Create options 
    let options = { headers: headers };

    // Pack Update Request
    var updateRequest = new HttpParams()
      .set('iUserID', userId);

    return this.http.post(this.apiUrl + '/TCPublic/loginModule/update_user', updateRequest, options);
  }


 // ******************************************************** HEADER FOOTER ************************************************************

  // -- FUNC Get Countries
  public getCountries(): Observable<Country[]> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    return this.http.post<Country[]>(
      this.apiUrl + '/TCPublicSite/profileModule/get_countries/format/json', null,
      options)
  }


  // -- FUNC Get All Categories
  public getAllCategories(): Observable<Category[]> {

    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    return this.http.get<Category[]>(
      this.apiUrl + '/TCPublicSite/headerFooterModule/get_all_categories_with_subcategories/format/json',
      options)

  }


  // -- FUNC Get Rate For User Currency
  public getRateForUserCurrency(userCurrencyCode: string) {

    // pack get user currency rate request
    var getUserCurrencyRateRequest = new HttpParams()
      .set('q', 'CNY_' + userCurrencyCode)
      .set('compact', 'ultra')
      .set('apiKey', '2f7ed345-a35e-4e58-bb96-039ddfb3ed99');

    return this.http.get('https://api.currencyconverterapi.com/api/v5/convert', {
      params: getUserCurrencyRateRequest
    })
  }


  // -- FUNC Get All Categories
  public getCategories(): Observable<Category[]> {
    return this.http.get<Category[]>(this.apiUrl + 'categories.json');
  }


  // -- FUNC Get Searched Products For Request
  public getSearchedProductsForRequest(searchRequest: string): Observable<Product[]> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    // pack get new product request
    var getNewProductRequest = new HttpParams()
      .set('countryId', '1')
      .set('searchRequest', searchRequest);

    return this.http.post<Product[]>(
      this.apiUrl + '/TCPublicSite/headerFooterModule/get_searched_products_for_search_request/format/json',
      getNewProductRequest,
      options)
  }


  // -- FUNC Subscribe To News Request
  public subscribeToNews(email: string) {

    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    // pack subscribe to new request
    var subscribeToNewsRequest = new HttpParams()
      .set('email', email);

    return this.http.post(
      this.apiUrl + '/TCPublicSite/headerFooterModule/subscribe_to_news_with_email/format/json',
      subscribeToNewsRequest,
      options)

  }


 // ************************************************************ HOME ************************************************************
  // -- FUNC Get New Products For Home
  public getNewProductsForHome(): Observable<Product[]>
  {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers};

    // pack get new product request
    var getNewProductRequest = new HttpParams()
      .set('countryId', String(this.Data.user.countryID));

    return this.http.post<Product[]>(
      this.apiUrl + '/TCPublicSite/productPresentationModule/get_new_products_for_home/format/json',
      getNewProductRequest,
      options)
  }


  // -- FUNC Get Discount Products For Home
  public getDiscountProductsForHome(): Observable<Product[]> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    // pack get discount product request
    var getDiscountProductRequest = new HttpParams()
      .set('countryId', String(this.Data.user.countryID));

    return this.http.post<Product[]>(
      this.apiUrl + '/TCPublicSite/productPresentationModule/get_discount_products_for_home/format/json',
      getDiscountProductRequest,
      options)
  }


  // -- FUNC Get Banners
  public getBanners(): Observable<Banner[]> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    return this.http.post<Banner[]>(
      this.apiUrl + '/TCPublicSite/productPresentationModule/get_all_banners/format/json', null,
      options)
  }


  // -- FUNC Get Category Banners
  public getCategoryBanners(): Observable<CategoryBanner[]> {
      // Create headers for request
      let headers = this.getHeader();

      // Create Options 
      let options = { headers: headers };

    return this.http.post<CategoryBanner[]>(
      this.apiUrl + '/TCPublicSite/productPresentationModule/get_all_category_banners/format/json', null,
        options)
  }


  // ************************************************* CATEGORY PRODUCTS ****************************************************
  // -- FUNC Get Category Products
  public getCategoryProducts(subCategoryId: string): Observable<Product[]> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    // pack get new product request
    var getCategoryProductsRequest = new HttpParams()
      .set('subCategoryID', subCategoryId)
      .set('countryId', String(this.Data.user.countryID));

    return this.http.post<Product[]>(
      this.apiUrl + '/TCPublicSite/productPresentationModule/get_products_for_subCategory/format/json',
      getCategoryProductsRequest,
      options)
  }


  // ************************************************* PRODUCT PAGE ****************************************************
  // -- FUNC Get Product By Id 
  public getProductById(id): Observable<Product> {

    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    // pack get new product request
    var getProductRequest = new HttpParams()
      .set('productId', id)
      .set('countryId', String(this.Data.user.countryID));

    return this.http.post<Product>(
      this.apiUrl + '/TCPublicSite/productPresentationModule/get_product_for_product_page/format/json',
      getProductRequest,
      options)

  }


  // ************************************************** CART MODULE ******************************************************

  // -- FUNC Get Countries Regions And Deliveries
  public getCountriesRegionsAndDeliveries(): Observable<any> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    return this.http.post<any>(
      this.apiUrl + '/TCPublicSite/cartModule/get_countries_regions_and_deliveries/format/json', null,
      options)
  }


  // -- FUNC Perform Save User Data From Order Formalization Page
  public performSaveUserDataFromOrderFormalizationPage(receivedSaveUserDataFromOrderFormalizationPageRequest: SaveUserDataFromOrderFormalizationPageRequest): Observable<any> {

    // Create headers for request
    let headers = this.getHeader();

    // Create options 
    let options = { headers: headers };

    // Pack Save Data Request
    var saveDataRequest = new HttpParams()
      .set('iUserID', receivedSaveUserDataFromOrderFormalizationPageRequest.userId)
      .set('vUserName', receivedSaveUserDataFromOrderFormalizationPageRequest.userName)
      .set('vPhone', receivedSaveUserDataFromOrderFormalizationPageRequest.userPhone)
      .set('countryID', receivedSaveUserDataFromOrderFormalizationPageRequest.userCountry)
      .set('provinceID', receivedSaveUserDataFromOrderFormalizationPageRequest.userProvince)
      .set('addressIndex', receivedSaveUserDataFromOrderFormalizationPageRequest.userIndex)
      .set('tAddress', receivedSaveUserDataFromOrderFormalizationPageRequest.userAdress);

    return this.http.post(this.apiUrl + '/TCPublicSite/cartModule/save_user_data_for_userID_from_order_form_page', saveDataRequest, options);
  }


  // -- FUNC Perform New Order Creation
  public performNewOrderCreation(orderRequest: NewOrderRequest): Observable<any> {


    // Create headers for request
    let headers = this.getHeader();

    // Create options 
    let options = { headers: headers };

    // serialize order products list
    var orderProductsListJsonString = "";
    var orderProductsArray = [];

    for (var i = 0; i < orderRequest.orderProducts.length; i++) {

      let jsonObject = {};
      orderRequest.orderProducts[i].forEach((value, key) => {
        jsonObject[key] = value
      });

      orderProductsArray.push(jsonObject);

    }

    orderProductsListJsonString += JSON.stringify(orderProductsArray);

    // Pack New Order Request
    var newOrderRequest = new HttpParams()
      .set('userID', orderRequest.userID)
      .set('platform', orderRequest.platform)
      .set('receiverName', orderRequest.receiverName)
      .set('receiverPhone', orderRequest.receiverPhone)
      .set('countryID', orderRequest.adressCountry)
      .set('provinceID', orderRequest.adressProvince)
      .set('adress', orderRequest.adressAdress)
      .set('adressIndex', orderRequest.adressIndex)
      .set('receiverNote', orderRequest.receiverNote)
      .set('productsCost', orderRequest.orderProductsTotalCost)
      .set('productsTotalDiscount', orderRequest.productsTotalDiscount)
      .set('weight', orderRequest.orderWeight)
      .set('deliveryID', orderRequest.deliveryID)
      .set('deliveryCost', orderRequest.orderDeliveryCost)
      .set('deliveryDayEstim', orderRequest.orderDeliveryDayEstimation)
      .set('orderUserCountryId', orderRequest.orderUserCountryId)
      .set('orderTotalCost', orderRequest.orderTotalCost)
      .set('orderTotalCostWithoutDiscount', orderRequest.orderTotalCostWithoutDiscount)
      .set('rmbUsdRate', orderRequest.rmbUsdRate)
      .set('discountCertificateId', orderRequest.orderDiscountCertificateId)
      .set('discountCouponId', orderRequest.orderDiscountCouponId)
      .set('discountCouponSumInRMB', orderRequest.orderDiscountCouponSumInRMB)
      .set('orderProductsList', orderProductsListJsonString);

    return this.http.post(this.apiUrl + '/TCPublicSite/cartModule/add_order', newOrderRequest, options);

  }


  // -- FUNC Perform Order Payment 
  public performOrderPayment(orderPaymentRequest: OrderPaymentRequest): Observable<any> {

    // Create headers for request
    let headers = this.getHeader();

    // Create options 
    let options = { headers: headers };

    // Pack Payment Request
    var paymentRequest = new HttpParams()
      .set('orderId', orderPaymentRequest.orderId)
      .set('type', orderPaymentRequest.orderPaymentMethodType)
      .set('paymentId', orderPaymentRequest.orderPaymentMethodId)
      .set('actualTotalCostAndCurrency', orderPaymentRequest.orderActualTotalCostAndCurrency)
      .set('rmbUserCurrencyRate', orderPaymentRequest.rmbUserCurrencyRate)
      .set('userCurrencySign', orderPaymentRequest.userCurrencySign)
      .set('userCurrencyIsDecimal', orderPaymentRequest.userCurrencyIsDecimal);


    return this.http.post(this.apiUrl + '/TCPublicSite/profileModule/pay_order/format/json', paymentRequest, options);

  }


  // -- FUNC Perform Order Cancel 
  public performOrderCancel(orderId: string, stockId: string): Observable<any> {

    // Create headers for request
    let headers = this.getHeader();

    // Create options 
    let options = { headers: headers };

    // Pack Cancel Order Request
    var cancelOrderRequest = new HttpParams()
      .set('orderId', orderId)
      .set('stockId', stockId);

    return this.http.post(this.apiUrl + '/TCPublicSite/profileModule/cancel_order/format/json', cancelOrderRequest, options);

  }


  // ************************************************ PROFILE MODULE *****************************************************
  // -- FUNC Get Existing Orders Short For Current User
  public geExistingOrdersShortForCurrentUser(userID: string): Observable<OrderShort[]> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    // pack get new product request
    var existingOrdersForUserIDRequest = new HttpParams()
      .set('userID', userID);

    return this.http.post<OrderShort[]>(
      this.apiUrl + '/TCPublicSite/profileModule/get_orders_for_userID/format/json', existingOrdersForUserIDRequest,
      options)
  }


  // -- FUNC Get Countries And Regions
  public getCountriesAndRegions(): Observable<any> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    return this.http.post<any>(
      this.apiUrl + '/TCPublicSite/profileModule/get_countries_and_regions/format/json', null,
      options)
  }


  // -- FUNC Get Countries And Regions
  public perfromGetAllUserDiscountCertificatesAndCoupons(userID: string): Observable<any> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    // pack get disocunts for user id request
    var getDiscountsForUserIDRequest = new HttpParams()
      .set('iUserID', userID);

    return this.http.post<any>(
      this.apiUrl + '/TCPublicSite/discountCertificatesModule/get_all_user_discount_certificates_and_coupons/format/json', getDiscountsForUserIDRequest,
      options)
  }


  // -- FUNC Perform Save User Data 
  public performSaveUserData(receivedSaveUserDataRequest: SaveUserDataRequest): Observable<any> {

    // Create headers for request
    let headers = this.getHeader();

    // Create options 
    let options = { headers: headers };

    // Pack Save Data Request
    var saveDataRequest = new HttpParams()
      .set('iUserID', receivedSaveUserDataRequest.userId)
      .set('vUserName', receivedSaveUserDataRequest.userName)
      .set('vPhone', receivedSaveUserDataRequest.userPhone)
      .set('eGender', receivedSaveUserDataRequest.userGender)
      .set('birthdate', receivedSaveUserDataRequest.userBirthdate)
      .set('countryID', receivedSaveUserDataRequest.userCountry)
      .set('provinceID', receivedSaveUserDataRequest.userProvince)
      .set('addressIndex', receivedSaveUserDataRequest.userIndex)
      .set('tAddress', receivedSaveUserDataRequest.userAdress)
      .set('vCurrencyId', receivedSaveUserDataRequest.userCurrencyId);

    return this.http.post(this.apiUrl + '/TCPublicSite/profileModule/save_user_data_for_userID', saveDataRequest, options);
  }


  // -- FUNC Get Order Payment Data 
  public getOrderPaymentData(orderId: string): Observable<OrderPaymentRequest> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    // pack get order payment data request
    var getOrderPaymentRequest = new HttpParams()
      .set('orderID', orderId);

    return this.http.post<OrderPaymentRequest>(
      this.apiUrl + '/TCPublicSite/profileModule/get_selected_order_payment_data/format/json', getOrderPaymentRequest,
      options)
  }


  // **************************************************** PAYMENT ********************************************************
  // -- FUNC Send Payment Request To Yandex
  public sendPaymentRequestToYandex(mainUrl: string, authData: string, headers: HttpHeaders, body: any) {

    // Create options 
    let options = {
      headers: headers
    };


    const proxyurl = "https://cors-anywhere.herokuapp.com/";

    return this.http.post(proxyurl+'https://payment.yandex.net/api/v3/payments', body, options );

  }


  // -- FUNC Ask Yandex About Payment Result Request
  public askYandexAboutPaymentResult(mainUrl: string, headers: HttpHeaders) {

    // Create options 
    let options = {
      headers: headers
    };
    
    const proxyurl = "https://cors-anywhere.herokuapp.com/";
    const paymentRequestId = localStorage.getItem('currentPaymentRequestId');

    return this.http.get(proxyurl+'https://' + mainUrl + paymentRequestId, options);

  }


  // ************************************************** NEWS PAGE ******************************************************
  // -- FUNC Get News Posts
  public getNewsPosts(): Observable<NewsPost[]> {
    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };

    return this.http.post<NewsPost[]>(
      this.apiUrl + '/TCPublicSite/newsModule/get_all_newsposts', null,
      options)
  }


  // ************************************************* CONTACTS PAGE ****************************************************
  // -- FUNC Send Contact Email
  public sendContactEmail(name: string, email: string, phone: string, message: string) {

    // Create headers for request
    let headers = this.getHeader();

    // Create Options 
    let options = { headers: headers };
    
    // pack send email request
    var sendEmailRequest = new HttpParams()
      .set('name', name)
      .set('email', email)
      .set('phone', phone)
      .set('message', message);

    return this.http.post(
      this.apiUrl + '/TCPublicSite/contactsModule/send_email_from_contact/format/json',
      sendEmailRequest,
      options)

  }


  // *********************************************** SHARED FUNCTIONS *****************************************************
  // -- FUNC Get Header 
  private getHeader(): HttpHeaders{

    // local
    /*headers = new HttpHeaders({
      'X-API-KEY': '6e8bf09219bd2046403ad1990e1b624e8e13269e',
      'iUserId': '2121',
      'accesstoken': 'b4929f544f365b1166a85add4bee935e'
    });*/

    // prod dev
    /*headers = new HttpHeaders({
      'X-API-KEY': 'b96fbe8a22cbb97647439b162ca20cc0a00a58bd',
      'iUserId': '2121',
      'accesstoken': '58870790068878060f8f761911dde77b'
    });*/

    // prod 
  /*headers = new HttpHeaders({
    'X-API-KEY': '37243c113f578cfcc41a0fac547648d0bf826da6',
    'iUserId': '2121',
    'accesstoken': '5826f8c147a81bda1ddbb52b838026cc'
  });*/

    // Create headers for request
    let headers;
    if (!this.isUserLoggedIn) {

      headers = new HttpHeaders({
        'X-API-KEY': 'e589ecb876b6abf03e41922ae8bc5e1d1e508746',
        'iUserId': '2121',
        'accesstoken': 'c86b74b94e9bb735316e6cc77c17908d'
    });
    }
    else {
      headers = new HttpHeaders({
        'X-API-KEY': localStorage.getItem('ReceivedApiSecurityKey'),
        'iUserId': this.Data.user.iUserID.toString(),
        'accesstoken': this.Data.user.accesstoken
      });
    }

    return headers;
  }


  // -- FUNC Get Currensies
  public getCurrencies() {
    return [
      {
        id: '0',
        code: 'CNY',
        sign: '¥',
        name: 'Китайские Юани',
        shortName: 'yuans'
      },
      {
        id: '1',
        code: 'USD',
        sign: '$',
        name: 'Американские Доллары',
        shortName: 'dollar'
      },
      {
        id: '2',
        code: 'RUB',
        sign: '₽',
        name: 'Русские Рубли',
        shortName: 'ruble'
      },
      {
        id: '3',
        code: 'KZT',
        sign: '₸',
        name: 'Казахские Тенге',
        shortName: 'tenge'
      },
      {
        id: '4',
        code: 'UAH',
        sign: '₴',
        name: 'Украинские Гривны',
        shortName: 'grivna'
      },
      {
        id: '5',
        code: 'BYN',
        sign: 'Br',
        name: 'Белорусские Рубли',
        shortName: 'belRuble'
      }
    ];
  }


    // -- FUNC Get Delivery Methods
    public getDeliveryMethods(){
        return [
            { value: 'free', name: 'Free Delivery', desc: '$0.00 / Delivery in 7 to 14 business Days' },
            { value: 'standard', name: 'Standard Delivery', desc: '$7.99 / Delivery in 5 to 7 business Days' },
            { value: 'express', name: 'Express Delivery', desc: '$29.99 / Delivery in 1 business Days' }
        ]
    }

} 
